import React, { useRef, useEffect } from 'react';

function MailPreview({ selectedCommandeForPreview, generateMailPreview }) {
    const iframeRef = useRef<HTMLIFrameElement>(null);

    useEffect(() => {
        const iframe = iframeRef.current;
        if (!iframe || !selectedCommandeForPreview) return;

        const html = generateMailPreview(selectedCommandeForPreview);
        const doc = iframe.contentDocument || iframe.contentWindow?.document;
        if (doc) {
            doc.open();
            doc.write(html);
            doc.close();

            const adjustHeight = () => {
                iframe.style.height = doc.body.scrollHeight + 'px';
            };
            adjustHeight();

            const imgs = doc.images;
            if (imgs && imgs.length > 0) {
                let loaded = 0;
                for (let img of imgs) {
                    img.onload = () => {
                        loaded++;
                        if (loaded === imgs.length) adjustHeight();
                    };
                }
            }
        }
    }, [selectedCommandeForPreview, generateMailPreview]);

    return (
        <iframe
            key={selectedCommandeForPreview?.id} // 🔑 force recréation de l'iframe à chaque message
            ref={iframeRef}
            title="Aperçu du message"
            style={{
                width: '100%',
                border: 'none',
                borderRadius: '8px',
                overflow: 'hidden',
                display: 'block',
                transition: 'height 0.3s ease',
            }}
            sandbox="allow-same-origin"
            referrerPolicy="no-referrer"
        />
    );
}

export default MailPreview;